import { useLocation } from "@shared/react-router-dom/react-router-dom";

const usePractitionerType = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  return searchParams.get("prac-type");
};

export { usePractitionerType };
